module.exports = __webpack_public_path__ + "img/R2BE1C.812e5477.svg";